import { useEffect, useState } from 'react';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { connect } from 'react-redux';
import { Card, CardContent, Form, Grid, Popup, Icon } from 'semantic-ui-react';
import { isEmailValid, validatePassword } from '../../../utils/string';
import { Button, message } from 'antd';
import Auth from '@aws-amplify/auth';
import { LoginFormState } from '../../admin/pages/Interfaces';
import PasswordStrengthBar from 'react-password-strength-bar';
import { translations } from '../../../utils/LocalizedStrings';

const UserRegistrationForm = ({
  setFormState,
  setIsLoading
}
) => {

  const [formData, setFormData] = useState({});
  const [validEmail, validateEmail] = useState(true);
  const [isPhoneNumberValid, setPhoneNumberValid] = useState(true);
  const [verifyCognito, setVerifyCognito] = useState(false);

  const handleField = (e) => {
    e.persist();
    setFormData((old) => ({ ...old, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const validationMessage = validateData(formData)

    if (validationMessage === '') {
      setIsLoading(true)
      try {
        const { user } = await Auth.signUp({
          username: formData.kontakt_email,
          password: formData.pass1,
          attributes: {
            given_name: formData.given_name,
            family_name: formData.family_name,
            phone_number: formData.phone_number,
            'custom:marketing_suhlas': formData['custom:marketing_suhlas'] ? formData['custom:marketing_suhlas'].toString() : 'false'
          }
        });
        message.info("Registrácia bola úspešná.", 20)
        setFormState(LoginFormState.LOGIN)
      } catch (error) {
        message.error('Registrácia nebola úspešná.')
      }
      setIsLoading(false)
    } else {
      message.error(validationMessage)
    }
  };

  useEffect(() => {
    if (formData.kontakt_phone && formData.kontakt_phone.length > 0) {
      setPhoneNumberValid(isValidPhoneNumber(formData.kontakt_phone))
    } else {
      setPhoneNumberValid(true)
    }
  }, [formData])

  const validateData = (formData) => {

    let messages = '';

    if (formData.given_name === undefined || formData.given_name === '') {
      messages += "Zadajte krstné meno ";
    }
    if (formData.family_name === undefined || formData.family_name === '') {
      messages += "Zadajte priezvisko ";
    }
    if (formData.kontakt_email === undefined || !isEmailValid(formData.kontakt_email)) {
      messages += "Neplatný email ";
    }
    if ((
      (!(formData.phone_number === undefined)) &&
      formData.phone_number.length > 0 &&
      !isValidPhoneNumber(formData.phone_number)
    )) {
      messages += "Neplatne telefónne číslo";
    }
    if (formData.pass1 === undefined || (formData.pass1 !== formData.pass2)) {
      messages += "Heslá sa nezhodujú";
    }
    if (!validatePassword(formData.pass1)) {
      messages += "Heslo musí obsahovať aspoň jedno velké a malé písmeno, aspoň jednu číslicu a aspoň 8 znakov";
    }
    return messages;
  }


  return (
    <main id="login" className='registerForm'>
      <div id='mainWrapper'>
        <div className='register-form-modal-container'>
          <span className='stepBackArrow' onClick={() => setFormState(LoginFormState.LOGIN)}>
            <Popup className='stepBackArrowPopup' content='Krok späť' trigger={<Icon name="arrow left" />} />
          </span>
          <header className='loginHeader'>Registrácia</header>
          <Form onSubmit={handleSubmit} className="orderUiForm">
            <Form.Field className="contactField nameSurmanePhone">
              <Form.Input
                label="Meno"
                name="given_name"
                value={formData.given_name}
                onChange={handleField}
                required
              />
              <Form.Input
                label={translations.artifacts.UserRegistrationBox.surname}
                name="family_name"
                value={formData.family_name}
                onChange={handleField}
                required
              />
            </Form.Field>
            <Form.Field className="contactField nameSurmanePhone" style={{ position: 'relative' }}>
              {formData.pass1 && formData.pass1.length > 0 &&
                < PasswordStrengthBar scoreWords={['veľmi slabé', 'slabé', 'dobré', 'silné', 'veľmi silné']} shortScoreWord="krátke" className='passwordStrengthBar' password={formData.pass1} />
              }
              <Form.Input
                label="Heslo"
                name="pass1"
                value={formData.pass1}
                onChange={handleField}
                required
                type='password'
              />
              <Form.Input
                className='repeatPassword'
                label="Heslo opakovať"
                name="pass2"
                value={formData.pass2}
                onChange={handleField}
                required
                type='password'
                error={
                  formData.pass1 === formData.pass2
                    ? false
                    : {
                      content: 'Heslá sa nezhodujú',
                    }
                }
              />
            </Form.Field>
            <Form.Field className="contactField nameSurmanePhone emailInput">
              <Form.Input
                label="E-mail(used for login too)"
                id={'emailInputCheckoutForm'}
                name="kontakt_email"
                className={validEmail ? '' : "invalid"}
                value={formData.kontakt_email}
                onChange={(e) => {
                  handleField(e);
                  validateEmail(isEmailValid(e.target.value));
                }}
                error={
                  validEmail
                    ? false
                    : {
                      content: 'Prosím zadajte platný email.',
                    }
                }
                required
              />
              <div className="field">
                <div className={formData.kontakt_phone &&
                  !isValidPhoneNumber(formData.kontakt_phone) ? 'phoneInputLabel invalid' : 'phoneInputLabel'}>{translations.artifacts.UserRegistrationBox.telephone}</div>
                <PhoneInput
                  labels={'test'}
                  id={'phoneNumberInputCheckoutForm'}
                  name="kontakt_phone"
                  value={formData.phone_number}
                  defaultCountry="SK"
                  withCountryCallingCode={true}
                  useNationalFormatForDefaultCountryValue={true}
                  className={(isPhoneNumberValid) ? 'valid' : 'invalid'}
                  onChange={(value) => {
                    setFormData((old) =>
                      JSON.parse(
                        JSON.stringify({ ...old, ['phone_number']: value }),
                      ),
                    );
                  }}
                />
                {formData.phone_number &&
                  !isValidPhoneNumber(formData.phone_number) &&
                  <div className='ui pointing above prompt label'>{translations.artifacts.UserRegistrationBox.pleaseEnterFullNumber}</div>
                }
              </div>
            </Form.Field>
            {/* <Form.Field className="registerFormMarketingCheckbox">
            <Form.Input
            name="custom:marketing_suhlas"
            checked={formData["custom:marketing_suhlas"]}
            onChange={(e) => {
              setFormData((old) => ({ ...old, [e.target.name]: e.target.checked }));
              }}
              type='checkbox'
              />
              {translations.artifacts.UserRegistrationBox.iAgree}
              </Form.Field> */}
            <Form.Field className="contactField nameSurmanePhone registerButton">
              <Button
                className="ui primary big button"
                type="submit"
                onClick={handleSubmit}
              >Registrovať</Button>
            </Form.Field>
          </Form>
        </div>
      </div>
    </main>
  );
};

const mapStateToProps = ({ appState }) => ({
  company: appState.company
});

export default connect(mapStateToProps)(UserRegistrationForm);
